module.exports = __webpack_public_path__ + "static/media/DCI-Certificate.a7d85e4d.pdf";